import "core-js/modules/es6.function.name";
import contantSearch from "./index.vue";
contantSearch.install = function (Vue) {
  Vue.component(contantSearch.name, contantSearch);
};
export default contantSearch;